$component-class: 'breadcrumbs-type-1';

.#{$component-class} {
  &__list {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: calc(var(--spacing-2xs) / 1.25);
  }

  &__item {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing-2xs) * 1.2);

    &:last-child {
      .#{$component-class}__separator {
        display: none;
      }
    }
  }

  &__link,
  &__text {
    @include text-style('sm', 'md');

    color: var(--text-color-primary);
    text-decoration: none;
    transition: color 0.2s ease;
  }

  &__link {
    &:hover {
      color: var(--color-brand-primary-dark);
    }
  }

  &__text {
    color: var(--text-color-primary);
    font-weight: map-get($font-weights, 'normal');
  }

  &__item--current &__text {
    color: color-mix(in srgb, var(--text-color-primary) 75%, transparent);
    font-weight: map-get($font-weights, 'normal');
    text-decoration: none;
  }

  &__separator {
    display: flex;
    align-items: center;
    margin-top: 3px;
    color: var(--text-color-secondary);

    .me-icon {
      @include size(16px);

      svg {
        fill: var(--color-neutral-neutral-light);
      }
    }
  }

  &--dark {
    .#{$component-class}__link,
    .#{$component-class}__text {
      color: var(--text-color-alternate);
    }

    .#{$component-class}__text {
      color: var(--color-neutral-neutral);
    }

    .#{$component-class}__link:hover {
      color: var(--color-brand-primary-dark);
    }

    .#{$component-class}__separator {
      color: var(--text-color-alternate);

      .me-icon {
        svg {
          fill: var(--color-neutral-neutral);
        }
      }
    }
  }
}
